var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtstationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 26.5838L3.04088 31.8398C3.66188 33.0705 4.91625 33.8434 6.2865 33.8434H26.4724L22.2829 26.5838H0ZM36 26.6186C36 25.8975 35.7829 25.218 35.4195 24.6499L23.589 4.08939C22.9624 2.90027 21.726 2.15552 20.3783 2.15552H14.1266L32.3966 33.8074L35.28 28.8214C35.8425 27.8663 36 27.4444 36 26.6186ZM19.3061 21.4279L11.1443 7.28889L2.97675 21.4279H19.3061Z",
    fill: "url(#paint0_linear_263_120)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_120",
    x1: 2.42545,
    y1: 6.29476,
    x2: 35.5726,
    y2: 14.5052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstationIcon);
export default __webpack_public_path__ + "static/media/artstation-icon.eb3caa7c03a7a941e8ed5518540cfe5d.svg";
export { ForwardRef as ReactComponent };